<script>
	let hereKitty = false;

	window.onscroll = function() {
		const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
		if (scrollTop > 500) {
			hereKitty = true;
		} else {
			hereKitty = false;
		}
	};
</script>

<!-- creative commons BY-NC http://www.pngall.com/kitten-png/download/7247 -->
<img
	class:curious={hereKitty}
	alt="Kitten wants to know what's going on"
	src="https://svelte.jp/tutorial/kitten.png"
>

<style>
	img {
		position: sticky;
		left: 0;
		bottom: -60px;
		transform: translate(-80%, 0) rotate(-30deg);
		transform-origin: 100% 100%;
		transition: transform 0.4s;
	}

	.curious {
		transform: translate(-15%, 0) rotate(0deg);
	}
</style>
